import type { RunTallies } from "../protocol/snapshot";
import { totalUnits } from "./composition";
import type { EngineState } from "./state";

/**
 * Run tallies — `02-cards-and-economy.md` §5's raw facts (Target Yield, Purity
 * Rate, Speed, Valorization), reported plainly rather than priced. `0026`
 * turns the engine's old points formula into this: the engine still knows
 * nothing about Credits, and pricing these numbers is `@reagent/meta`'s job.
 *
 * Integer arithmetic throughout, and derived purely from state, so a tally is
 * exactly reproducible from a seed and can be recomputed at any moment rather
 * than accumulated (which would drift the instant a rule changed).
 */

/** Unit-weighted mean purity of everything that scored, 0-100. */
export function averagePurity(state: EngineState): number {
  if (state.scoredUnits <= 0) return 0;
  return Math.round(state.purityUnitsWeighted / state.scoredUnits);
}

export function tallyOf(state: EngineState): RunTallies {
  return {
    scoredUnits: totalUnits(state.collected),
    targetUnits: totalUnits(state.stage.objective.targetComposition),
    averagePurity: averagePurity(state),
    valorizedUnits: state.valorizedUnits,
    wastedUnits: state.wastedUnits,
    ventedUnits: state.ventedUnits,
    turnsUsed: state.turn,
    maxTurns: state.stage.maxTurns,
  };
}
